// extracted by mini-css-extract-plugin
export var noSpinners = "_np-6";
export var percentageInput = "_np-7";
export var variantColor1 = "_np-0";
export var variantColor2 = "_np-1";
export var variantColor3 = "_np-2";
export var variantColor4 = "_np-3";
export var variantColor5 = "_np-4";
export var variantColor6 = "_np-5";